/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export default (function (_ref) {
  var _ref$oldBounds = _ref.oldBounds,
      oldBounds = _ref$oldBounds === void 0 ? {} : _ref$oldBounds,
      _ref$newBounds = _ref.newBounds,
      newBounds = _ref$newBounds === void 0 ? {} : _ref$newBounds;
  return oldBounds.top !== newBounds.top || oldBounds.left !== newBounds.left || oldBounds.width !== newBounds.width || oldBounds.height !== newBounds.height;
});